export const FIND_OFFERS = 'OVID/OFFERS/FIND_OFFERS'
export const FIND_OFFERS_SUCCESS = 'OVID/OFFERS/FIND_OFFERS_SUCCESS'
export const FIND_OFFERS_FAILED = 'OVID/OFFERS/FIND_OFFERS_FAILED'
